import React, { useEffect, useState } from 'react'
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar';
import { VariableTransactions } from './VariableTransactions';
import SelectDropDown from '../../../components/elements/SelectDropDown';
import { filterTransaction, getPageListTransaction } from '../../../store/Actions/ActionTransactions';
import { useSelectorCustom } from '../../../components/general/general-component/abstruct-component/useSelectorCustom';

function FilterTransactions({ translate, noPadding, bigTitle }) {
    const { dispatch, navigate, langLocal } = AbstructVar()
    const { state, setStateCustom, setLoad, handleChangeDate } = VariableTransactions();
    const { page_list_transaction, loadingPageListTransaction } = useSelectorCustom()
    const [accountId, setAccountId] = useState('')
    useEffect(() => {
        dispatch(getPageListTransaction())
    }, [])
    const Filter = (e) => {
        e.preventDefault()
        dispatch(filterTransaction(state.search_value, state.account_id,state.date,state.transaction_type,state?.user_id,state.status, setLoad))
    }
    return (
        <div className='filteruser ' dir={langLocal === 'ar' ? "rtl" : "ltr"} style={noPadding && { padding: "4px 0px 10px 0px" }} >
            {
                bigTitle ? <h2 className="main_title_color" >{translate('search_filter')}</h2> :
                    <h3>{translate('search_filter')}</h3>
            }
            <div className='div_filter' style={{ marginTop: '0px' }} >
                <div style={{ marginTop: "15px" }} className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} new-input-filter w-24`} >
                    <input type='text' className={`input_filter1 ${langLocal === 'ar' ? "margin_left_25" : "margin_right_25"} `} placeholder={translate('search')} onChange={(e) => setStateCustom('search_value', e.target.value)} />
                </div>
                <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-24`} style={{ fontSize: "14px" }} >
                    <SelectDropDown
                        placeholder={translate('account')}
                        options={page_list_transaction?.accounts?.map((account) => ({
                            label: account?.name, value: account?.id
                        }))}
                        varr={state?.account_id}
                        setVarr={(value) => setStateCustom('account_id', value)}
                    />
                </div>
                <div style={{ marginTop: "15px" }} className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} new-input-filter w-24`} >
                    <input type='date' className={`input_filter1 ${langLocal === 'ar' ? "margin_left_25" : "margin_right_25"} `} placeholder={translate('date')} onChange={(e) => setStateCustom('date', e.target.value)} />
                </div>
                <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-24`} style={{ fontSize: "14px" }} >
                    <SelectDropDown
                        placeholder={translate('users')}
                        options={page_list_transaction?.users?.map((account) => ({
                            label: account?.name, value: account?.id
                        }))}
                        varr={state?.user_id}
                        setVarr={(value) => setStateCustom('user_id', value)}
                    />
                </div>
                <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-24`} style={{ fontSize: "14px" }} >
                    <SelectDropDown
                        placeholder={translate('transaction_type')}
                        options={page_list_transaction?.all_transaction_types}
                        varr={state?.transaction_type} 
                        setVarr={(value) => setStateCustom('transaction_type', value)}
                    />
                </div>
                <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-24`} style={{ fontSize: "14px" }} >
                    <SelectDropDown
                        placeholder={translate('status')}
                        options={[{label: "active",value: 1},{label: "unactive",value: 0}]}
                        varr={state?.status}
                        setVarr={(value) => setStateCustom('status', value)}
                    />
                </div>
                <button className='btn_filter' onClick={Filter} style={{ marginBottom: "0px" }} >
                    {
                        state.Load ? "Loading ..." : `${translate('filter')}`
                    }
                </button>
            </div>
        </div>
    )
}

export default FilterTransactions

